// extracted by mini-css-extract-plugin
export default {"sortable-item":"SortableItem_sortable-item__S+aYI","sortable-item--dragging":"SortableItem_sortable-item--dragging__R4LkP"};